import React from 'react'
import AboutUsTitle from './About-us-title';
import AboutUsInfo from './About-us-info';

const AboutUs = () => {
    return <div>
    <AboutUsTitle />
    <AboutUsInfo />
    </div> ;
  };

  export default AboutUs; 
